!function (n, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(n.TypesafeActions = {});
}(this, function (n) {
  "use strict";

  function t(n, t, r) {
    return {
      type: n,
      payload: t,
      meta: r
    };
  }

  function r(n, t) {
    if (void 0 === t && (t = 1), null == n) throw new Error("Argument (#" + t + ") is missing");
    if ("string" != typeof n && "symbol" != typeof n) throw new Error("Argument (#" + t + ") should be of type: string | symbol");
  }

  function e(n, t) {
    var r = null != t ? t(n) : function () {
      return {
        type: n
      };
    };
    return Object.assign(r, {
      getType: function getType() {
        return n;
      },
      toString: function toString() {
        return n;
      }
    });
  }

  n.action = t, n.createAction = function (n, e) {
    r(n);
    var i = null == e ? function () {
      return t(n);
    } : e(t.bind(null, n));
    return Object.assign(i, {
      getType: function getType() {
        return n;
      },
      toString: function toString() {
        return n;
      }
    });
  }, n.createStandardAction = function (n) {
    return r(n), Object.assign(function () {
      return e(n, function (n) {
        return function (t, r) {
          return {
            type: n,
            payload: t,
            meta: r
          };
        };
      });
    }, {
      map: function map(t) {
        return e(n, function (n) {
          return function (r, e) {
            return Object.assign(t(r, e), {
              type: n
            });
          };
        });
      }
    });
  }, n.createAsyncAction = function (n, t, i) {
    return [n, t, i].forEach(function (n, t) {
      r(n, t + 1);
    }), Object.assign(function () {
      return {
        request: e(n, function (t) {
          return function (t) {
            return {
              type: n,
              payload: t
            };
          };
        }),
        success: e(t, function (n) {
          return function (n) {
            return {
              type: t,
              payload: n
            };
          };
        }),
        failure: e(i, function (n) {
          return function (n) {
            return {
              type: i,
              payload: n
            };
          };
        })
      };
    }, {});
  }, n.getType = function (n) {
    if (null == n) throw new Error("first argument is missing");
    if (null == n.getType) throw new Error('first argument is not an instance of "typesafe-actions"');
    return n.getType();
  }, n.isOfType = function (n, t) {
    Array.isArray(n) ? n.forEach(function (n) {
      return r(n);
    }) : r(n);
    var e = Array.isArray(n) ? function (t) {
      return n.includes(t.type);
    } : function (t) {
      return t.type === n;
    };
    return null == t ? e : e(t);
  }, n.isActionOf = function (n, t) {
    if (null == n) throw new Error("first argument is missing");
    if (Array.isArray(n)) n.forEach(function (n, t) {
      if (null == n.getType) throw new Error('first argument contains element\n        that is not created with "typesafe-actions" at index [' + t + "]");
    });else if (null == n.getType) throw new Error('first argument is not created with "typesafe-actions"');

    var r = function r(t) {
      return (Array.isArray(n) ? n : [n]).some(function (n, r) {
        return n.getType() === t.type;
      });
    };

    return null == t ? r : r(t);
  }, n.createActionDeprecated = function (n, t) {
    var r;

    if (null != t) {
      if ("function" != typeof t) throw new Error("second argument is not a function");
      r = t;
    } else r = function r() {
      return {
        type: n
      };
    };

    if (null == n) throw new Error("first argument is missing");
    if ("string" != typeof n && "symbol" != typeof n) throw new Error("first argument should be type of: string | symbol");
    return r;
  }, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});